export default __webpack_public_path__ + "static/media/13.bb3cebf5.png";